import { useState } from "react";
import { MapPin, Phone, Menu, X } from "lucide-react";
import { trackPixel } from "@/lib/fbpixel";

const LOGO_URL = "/assets/img/logo.webp";

const navLinks = [
  { label: "Início", href: "#hero" },
  { label: "O Padel", href: "#padel" },
  { label: "Torneios", href: "#tournaments" },
  { label: "Quem somos", href: "#about" },
  { label: "Contactos", href: "#contacts" },
];

export default function TopBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-[#0a0f1a]/80 backdrop-blur-xl border-b border-white/5" data-testid="navbar">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 flex items-center justify-between h-14">
        {/* Left info */}
        <div className="hidden lg:flex items-center gap-6">
          <div className="flex items-center gap-2 text-white/40 text-xs">
            <div className="w-6 h-6 rounded-full bg-white/5 flex items-center justify-center">
              <MapPin size={11} className="text-jp-lime" />
            </div>
            <span>Barcelos, Portugal</span>
          </div>
          <div className="flex items-center gap-2 text-white/40 text-xs">
            <div className="w-6 h-6 rounded-full bg-white/5 flex items-center justify-center">
              <Phone size={11} className="text-jp-lime" />
            </div>
            <span>968 822 860</span>
          </div>
        </div>

        {/* Center logo */}
        <a href="#hero" data-testid="nav-logo" className="lg:absolute lg:left-1/2 lg:-translate-x-1/2">
          <img src={LOGO_URL} alt="Just Padel" width="200" height="100" className="h-14 w-auto" />
        </a>

        {/* Right nav - Desktop */}
        <div className="hidden md:flex items-center gap-1">
          <nav className="flex items-center gap-1">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="px-4 py-1.5 rounded-full text-xs font-medium text-white/50 hover:text-white hover:bg-white/5 transition-all"
                data-testid={`nav-link-${link.href.slice(1)}`}
              >
                {link.label}
              </button>
            ))}
          </nav>
          <a
            href="https://smashpro.pt/pt/justpadel-barcelos"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackPixel("InitiateCheckout")}
            className="ml-2 bg-jp-lime text-black font-semibold text-xs px-5 py-2 rounded-full hover:bg-jp-lime-dark transition-all flex items-center gap-1.5"
            data-testid="nav-booking-btn"
          >
            Reservar
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 10L10 2M10 2H4M10 2V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </a>
        </div>

        {/* Mobile menu button + Reservar */}
        <div className="flex md:hidden items-center gap-3">
          <a
            href="https://smashpro.pt/pt/justpadel-barcelos"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackPixel("InitiateCheckout")}
            className="bg-jp-lime text-black font-semibold text-xs px-4 py-2 rounded-full hover:bg-jp-lime-dark transition-all flex items-center gap-1.5"
            data-testid="nav-booking-btn-mobile"
          >
            Reservar
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 10L10 2M10 2H4M10 2V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </a>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition-all"
            data-testid="mobile-menu-btn"
            aria-label="Abrir menu de navegação"
          >
            {menuOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile menu dropdown */}
      {menuOpen && (
        <div className="md:hidden absolute top-14 left-0 w-full bg-[#0a0f1a]/95 backdrop-blur-xl border-b border-white/5">
          <nav className="flex flex-col py-4 px-6">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="py-3 text-left text-sm font-medium text-white/70 hover:text-jp-lime transition-colors border-b border-white/5 last:border-b-0"
                data-testid={`mobile-nav-link-${link.href.slice(1)}`}
              >
                {link.label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
